import { Route, Routes } from "react-router-dom";

import { ConsultationsRouter } from "@/features/consultations/router";
import { BASE_ROUTE } from "../constants";
import { LegacyRouter } from "./legacy-router";

export const PatientUserRouter = () => {
  return (
    <Routes>
      <Route path="*" element={<LegacyRouter />} />

      <Route
        path={`${BASE_ROUTE.CONSULTATIONS}/*`}
        element={<ConsultationsRouter />}
      />
    </Routes>
  );
};
